const root = "Submenu-module_root_BoW-D-ZP";
const main = "Submenu-module_main_nVQBDcyi";
const mainContent = "Submenu-module_mainContent_ty0jQwt5";
const aside = "Submenu-module_aside_1qzqnFiW";
const header = "Submenu-module_header_Z1yUzQOY";
const heading = "Submenu-module_heading_zJ9RGmal";
const description = "Submenu-module_description_JaFypvN1";
const sections = "Submenu-module_sections_XX2GHWNy";
const footer = "Submenu-module_footer_RN1Y7Vyf";
const footerList = "Submenu-module_footerList_-NsF12ii";
const footerLink = "Submenu-module_footerLink_9Jy4IGlQ";
const styles = {
  root,
  main,
  mainContent,
  aside,
  header,
  heading,
  description,
  sections,
  footer,
  footerList,
  footerLink
};
export {
  aside,
  styles as default,
  description,
  footer,
  footerLink,
  footerList,
  header,
  heading,
  main,
  mainContent,
  root,
  sections
};
